import {customElement, inject} from "aurelia-framework";
import {EventAggregator} from "aurelia-event-aggregator";
import {FlashService} from "../flash/flash-service";
import _ from "lodash";

import "./notification.less";

import {NotificationBase} from "./notification-templates/notification-base";
import {NotificationLinkbox} from "./notification-templates/notification-linkbox";
import {NotificationCallbox} from "./notification-templates/notification-callbox";
import {NotificationActionbox} from "./notification-templates/notification-actionbox";

import {IconService} from "./icon-service";

@customElement("sio-notification")
@inject(EventAggregator, FlashService, IconService)
export class Notification {
    constructor(ea, flash, iconService) {
        this.ea = ea;
        this.flash = flash;
        this.notificationsList = [];
        this.iconService = iconService;

        this.templates = {
            'info': NotificationBase,
            'success': NotificationBase,
            'error': NotificationBase,
            'warning': NotificationBase,
            'linkbox': NotificationLinkbox,
            'callbox': NotificationCallbox,
            'actionbox': NotificationActionbox
        };

        this.notificationSubscriber = ea.subscribe(
            "sio_notification",
            (data) => {
                let additionalFields = _.pickBy(
                    data,
                    function (value, key) {
                        return !['title', 'body', 'type', 'icon'].includes(key);
                    });

                const notification = {
                    id: Date.now(),
                    title: data?.title,
                    body: data?.body,
                    type: data?.type,
                    icon: data?.icon,
                    additionalFields: additionalFields,
                };

                this.notificationsList.unshift(notification);
                setTimeout(() => {
                    this.clearNotification(notification.id);
                }, 120 * 1000);
            }
        );
    }

    detached() {
        this.notificationSubscriber.dispose();
    }

    clearNotification(id) {
        this.notificationsList = this.notificationsList.filter(
            (item) => item.id !== id
        );
    }

    getTemplateForType(type) {
        return this.templates[type] || this.templates['info'];
    }

    getModelForNotification(notification) {
        return {
            notification: notification,
            icon: this.iconService.hasIcon(notification.icon) ? this.iconService.getIcon(notification.icon) : null,
            parent: this
        };
    }
}
